<script setup lang="ts">
import type { ScrollAreaRootProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { reactiveOmit } from "@vueuse/core"
import {
  ScrollAreaCorner,
  ScrollAreaRoot,
  ScrollAreaViewport,
} from "reka-ui"
import { cn } from "@/lib/utils"
import ScrollBar from "./ScrollBar.vue"

const props = withDefaults(
  defineProps<ScrollAreaRootProps & { class?: HTMLAttributes["class"]; orientation?: "vertical" | "horizontal" }>(),
  { orientation: "vertical" },
)

const delegatedProps = reactiveOmit(props, "class", "orientation")
</script>

<template>
  <ScrollAreaRoot
      data-slot="scroll-area"
      v-bind="delegatedProps"
      :class="cn('relative', props.class)"
  >
    <!-- No focus ring: it's a page-sized scroll container, and the ring/outline showed up as a border
         and shadow around the whole page (e.g. /bots) after a click or Esc moved focus onto it. -->
    <ScrollAreaViewport
        data-slot="scroll-area-viewport"
        class="size-full rounded-[inherit] outline-none"
    >
      <slot />
    </ScrollAreaViewport>
    <ScrollBar :orientation="orientation" />
    <ScrollAreaCorner />
  </ScrollAreaRoot>
</template>